import { useState } from "react"

interface ExportRequest {
   snackbarMessage: string
   closeSnackbar: () => void
   requestExport: (
      request: () => Promise<unknown>,
      subject: string
   ) => Promise<void>
}

const getSuccessMessage = (subject: string) =>
   `Data export started. Your ${subject} will be prepared and sent to your email. The link is valid for 12 hours.`

const getErrorMessage = (subject: string) =>
   `Something went wrong requesting the ${subject}. Please try again.`

export const useExportRequest = (): ExportRequest => {
   const [snackbarMessage, setSnackbarMessage] = useState("")

   const requestExport = async (
      request: () => Promise<unknown>,
      subject: string
   ) => {
      try {
         await request()
         setSnackbarMessage(getSuccessMessage(subject))
      } catch (err) {
         console.error(`Export request failed (${subject}):`, err)
         setSnackbarMessage(getErrorMessage(subject))
      }
   }

   const closeSnackbar = () => setSnackbarMessage("")

   return { snackbarMessage, closeSnackbar, requestExport }
}
